module.exports = __webpack_public_path__ + "img/q_img02.14c2c84c.jpg";